module.exports = __webpack_public_path__ + "static/headshot--casual--cropped-96e9aca1ab21f6ea1c4efc2ac034285c.jpeg";